export default __webpack_public_path__ + "static/media/diamond-cut-1@2x.f218715f.png";